import { rpOccurrenceProxy } from '../../rpOccurrenceProxy'
import { recurringPaymentProxy } from '../../../../../../../shared/proxies/recurringPaymentProxy'
import { rpOccurrenceEditProxy } from '../RpOccurrenceDetail/CardUpdateSlideover/rpOccurrenceEditProxy'
import { addToArray } from '../../../../../../../shared/utils/arrayUtils'
import {
  RpOccurrenceEditProxyFormFieldNamesEnum
} from '../RpOccurrenceDetail/CardUpdateSlideover/rpOccurrenceEditProxyFormFieldNamesEnum'

export const closeModal = (): void => { rpOccurrenceProxy.displayResolveModal = false }

export const openModal = (): void => {
  rpOccurrenceProxy.displayResolveModal = true
}

export const openRetrySlideOver = (): void => {
  rpOccurrenceProxy.displayUpdateCardSlideOver = true
  rpOccurrenceEditProxy.customer = rpOccurrenceProxy.rpOccurrence?.customer ?? null
  rpOccurrenceEditProxy.customerCard = rpOccurrenceProxy.rpOccurrence?.customerCard ?? null

  rpOccurrenceEditProxy.form.dirty = addToArray(rpOccurrenceEditProxy.form.dirty, RpOccurrenceEditProxyFormFieldNamesEnum.CustomerCard)
}
export const handleRadioChange = (radioValue: string): void => {
  recurringPaymentProxy.resolveRadioValue = radioValue
  recurringPaymentProxy.nextPaymentDate = null
}
